import { Loader2 } from "lucide-react";

export function LoadingScreen() {
	return (
		<div className="flex min-h-svh items-center justify-center">
			<Loader2 className="size-8 animate-spin text-primary" />
		</div>
	);
}
